<template>
  <div>
    <div class="section-right-content-box">
      <div class="box-shadow top-box">
        <div class="global-title">地域分布分析
          <el-popover
            placement="right"
            width="440"
            trigger="hover"
          >
            <div>1、新老客：首次付款时间在查询时间段内为新客，反之为老客。</div>
            <div>2、复购客户数：时间段内下单2次的客户数</div>
            <div>3、复购率：复购客户数/下单人数</div>
            <div>4、客单价：下单金额/下单人数</div>
            <i class="el-icon-question" slot="reference" style="color: #aaaaaa;"></i>
          </el-popover>
        </div>
      </div>
      <div class="region_distribution_analysis">
        <!-- 查询条件 -->
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="下单时间：" required>
            <el-radio
              v-for="item in radioList"
              :key="item.value"
              v-model="form.orderTimeType"
              :label="item.value"
              @change="orderTimeTypeChange"
              >{{ item.label }}</el-radio
            >
          </el-form-item>
          <el-form-item label="客户类型：">
            <el-select style="width: 204px;" v-model="form.customerType" placeholder="请选择">
              <el-option
                v-for="item in customerList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="form.orderTimeType == 0"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button class="status_btn status_btn1" icon="el-icon-search" type="primary" @click="queryData">查询</el-button>
            <el-button class="status_btn status_btn2" @click="resetData">重置</el-button>
            <el-button class="exportData" @click="exportData">导出数据</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background: '#fafafa', fontWeight: 700 }"
          style="width: 100%; margin-top: 24px;"
          show-summary
          :default-sort = "{prop: 'memberCount', order: 'descending'}"
          :summary-method="getSummaries"
          v-loading="loading"
        >
          <el-table-column prop="geography" label="地域" align="center">
          </el-table-column>
          <el-table-column prop="memberCount" label="会员下单数" align="center" sortable>
          </el-table-column>
          <el-table-column prop="orderPins" label="下单人数" align="center" sortable>
          </el-table-column>
          <el-table-column prop="returnBuyNum" label="复购人数" align="center" sortable>
          </el-table-column>
          <el-table-column prop="returnPercent" label="复购率" align="center" sortable>
            <template slot-scope="scope">
                {{ scope.row.returnPercent }}%
              </template>
          </el-table-column>
          <template slot="empty">
            <div class="empty">
              <img src="@/assets/images/default/暂无任何数据.png" />
              <div>暂无任何数据</div>
            </div>
          </template>
        </el-table>
      </div>
    </div>

    <!-- 生成报表 -->
    <generate
      v-if="control"
      :control="control"
      @transData="(val) => (control = val)"
      @transData1="getphone"
    />
  </div>
</template>

<script>
import generate from "@/components/generate_report.vue";
import { exportDataOne, getTableData } from "@/api/analysis/region_distribution_analysis";

export default {
  components: {
    generate,
  },

  data() {
    return {
      newMemberRateTotal: "", // 合计复购率
      loading: false,
      control: false,
      form: {
        // 表单查询条件
        orderTimeType: 1,
        customerType: 0,
      },
      radioList: [
        // 下单时间
        {
          label: "近30天",
          value: 1,
        },
        {
          label: "近90天",
          value: 2,
        },
        {
          label: "近180天",
          value: 3,
        },
        {
          label: "近一年",
          value: 4,
        },
        {
          label: "全部",
          value: 0
        },
      ],
      customerList: [
        // 客户类型
        {
          label: "不限",
          value: 0,
        },
        {
          label: "新客",
          value: 1,
        },
        {
          label: "老客",
          value: 2,
        },
      ],
      tableData: [], // 表格数据
      exportParams: {}, // 导出参数
    };
  },
  created() {
    // 埋点
    this.buriedPoint(1, "地域分布分析", "数据分析", "客户分析");
    this.queryData()
  },

  methods: {
    // 自定义合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (column.property == "returnPercent") {
            sums[index] = this.newMemberRateTotal + "%";
          }
        } else {
          sums[index] = 'N/A';
        }
      });
      return sums;
    },

    // 当“下单时间”选中“全部”时，“客户类型”自动选中“不限”且不支持选择其他值
    orderTimeTypeChange(val) {
      if (!val) {
        this.form.customerType = 0
      }
    },

    // 查询
    queryData() {
      this.exportParams = { ...this.form }
      this.loading = true
      getTableData(this.form).then((res) => {
        this.loading = false
        if (res.code != 1) {
          return this.$message.error(res.message || res.data.message)
        }
        if (res.data && res.data.length == 1) {
          res.data = []
          return
        }
        if (res.data && res.data.length > 1) {
          this.newMemberRateTotal = res.data[res.data.length - 1].returnPercent
          res.data.pop()
        }
        this.tableData = res.data || []
      })
    },

    // 重置
    resetData() {
      this.form = {
        orderTimeType: 1,
        customerType: 0,
      }
      this.queryData()
    },

    exportData() {
      this.control = true;
    },

    getphone(val) {
      exportDataOne({
        ...this.exportParams,
        exportRemark: val,
      }).then((res) => {
        if (res.code == 1) {
          this.control = true;
        } else {
          this.$message.error(res.message || res.data.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.section-right-content-box {
  min-width: 1046px;
  margin-top: 10px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;

  .region_distribution_analysis {
    padding: 28px;

    .status_btn {
      width: 98px;
      background-color: #fff;
      font-size: 14px;
      margin-left: 20px;
    }

    .status_btn1 {
      color: #fe4d45;
      border-color: #fe4d45;
      margin-left: 0;
    }

    .status_btn1:hover {
      color: #ffffff;
      background-color: #fe4d45;
    }

    .status_btn2 {
      margin-left: 8px;
      color: #333;
      border-color: #d9d9d9;
    }

    .status_btn2:hover {
      color: #fe4d45;
      border-color: #fe4d45;
      background-color: #ffe5e5;
    }

    .exportData {
      float: right;
    }

    .empty {
      padding: 40px 0;
      text-align: center;
      line-height: 30px;
    }

    .toolTipSet {
      width: 600px !important;
    }

    /deep/.el-table {
      overflow-x: auto;
    }
    /deep/.el-table__header-wrapper,
    .el-table__body-wrapper {
      overflow: visible;
    }
    /deep/.el-table__footer-wrapper {
      overflow: visible;
    }
    /deep/.el-table::after {
      position: relative;
    }
    /deep/.el-table--scrollable-x .el-table__body-wrapper {
      overflow: visible;
    }
  }
}
</style>
